import React, { PropTypes } from 'react'
import classnames from 'classnames'
import CSSModules from 'react-css-modules'

import Wysiwyg from '../wysiwyg'

import styles from './editable-field.css'

const EditableField = ({
  editable,
  hasError,
  icon,
  id,
  important,
  isNumeric,
  label,
  onChange,
  prefix,
  primary,
  value,
  type,
}) => {
  const renderField = () => {
    if (type === "wysiwyg") {
      return <Wysiwyg
        onChange={newValue => onChange({ target: { value: newValue } })}
        value={value}
        readOnly={!editable}
      />
    } else if (type === "textarea") {
      return <textarea
        value={value}
        disabled={!editable}
        id={id}
        onChange={onChange}
        styleName="field"
        type="text"
        pattern={isNumeric ? '[0-9]*' : ''}
      />
    }

    return <input
      value={value}
      disabled={!editable}
      id={id}
      onChange={onChange}
      styleName="field"
      type="text"
      pattern={isNumeric ? '[0-9]*' : ''}
    />
  }

  return (
    <div
      styleName={
        classnames({
          'container-editable': editable,
          'container-editable-error': editable && hasError,
          'container-editable-no-error': editable && !hasError,
          'container-normal': !editable,
          'content-primary-important': primary && important,
          'content-primary-normal': primary && !important,
          'content-secondary-important': !primary && important,
          'content-secondary-normal': !primary && !important,
        })
      }
    >
      {(icon || label) &&
        <div styleName="icon-wrapper-tablet">
          <span styleName="icon">{icon}</span>
        </div>
      }
      {label &&
        <div styleName="label-wrapper">
          <label htmlFor={id}>{label}</label>
        </div>
      }
      <div styleName="field-wrapper">
        {icon &&
          <div styleName="icon-wrapper-desktop">
            <span styleName="icon">{icon}</span>
          </div>
        }
        {prefix && <label styleName="prefix" htmlFor={id}>{prefix}</label>}
        {renderField()}
      </div>
    </div>
  )
}

EditableField.propTypes = {
  editable: PropTypes.bool,
  hasError: PropTypes.bool,
  icon: PropTypes.any,
  id: PropTypes.string,
  important: PropTypes.bool,
  isNumeric: PropTypes.bool,
  label: PropTypes.string,
  onChange: PropTypes.func,
  prefix: PropTypes.string,
  primary: PropTypes.bool,
  type: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
}

EditableField.defaultProps = {
  value: '',
}

export default CSSModules(EditableField, styles, { allowMultiple: true })



/** WEBPACK FOOTER **
 ** ./src/components/editable-field/editable-field.js
 **/